(ns common.schema.entities.counterparty-diligence.templates.demo.ubo
  (:require
   [common.schema.entities.counterparty-diligence.templates.questions.person :as person-q]
   [potpuri.core :as p]))

(def yes-no-options
  [{:value :yes
    :label "Yes"}
   {:value :no
    :label "No"}])

(def ubo-categories-options
  [{:key :shares-over-25
    :value :shares-over-25
    :translations {:en "Over 25% share ownership"
                   :fi "Yli 25% omistusoikeus"}}
   {:key :voting-rights-over-25
    :value :voting-rights-over-25
    :translations {:en "Over 25% voting rights"
                   :fi "Yli 25% äänivalta"}}
   {:key :right-to-dismiss-board
    :value :right-to-dismiss-board
    :translations {:en "Right to nominate or dismiss the majority of the board members"
                   :fi "Oikeus nimittää tai erottaa enemmistö hallituksen jäsenistä."}}
   {:key :mob-ceo-or-similar
    :value :mob-ceo-or-similar
    :translations {:en "Board member, CEO or equivalent position."
                   :fi "Hallituksen jäsen, toimitusjohtaja tai vastaava asema"}}])

;; TODO: in progress
(def schema
  {:template/schema
   (merge
    (->> [person-q/first-name
          person-q/last-name
          person-q/date-of-birth
          person-q/nationality
          person-q/type-of-identification-attachment
          person-q/identification-expiration-date]
         (p/index-by :field))

    {(:field person-q/passport-photo-page-file)
     (merge
      person-q/passport-photo-page-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/passport)))})}

    {(:field person-q/id-card-front-file)
     (merge
      person-q/id-card-front-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/id-card)))})}

    {(:field person-q/id-card-back-file)
     (merge
      person-q/id-card-back-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/id-card)))})}

    {:primary-ubo-category
     {:label {:en "This person is considered an UBO due to"}
      :data-type :data.type/keyword
      :options ubo-categories-options}})

   :template/sections
   {:ubo-position
    {:ord 0
     :title {:en "Reason for UBO"}
     :fields [:primary-ubo-category]}

    :basic-information
    {:ord 1
     :title {:en "Basic information"}
     :fields (->> [person-q/first-name
                   person-q/last-name
                   person-q/date-of-birth
                   person-q/nationality]
                  (mapv :field))}

    :identification
    {:ord 2
     :title {:en "Identification"}
     :fields (->> [person-q/type-of-identification-attachment
                   person-q/identification-expiration-date
                   person-q/passport-photo-page-file
                   person-q/id-card-front-file
                   person-q/id-card-back-file]
                  (mapv :field))}}})
